export const defaultZoomLevel = 15;

export const GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_WIDTH = '146';
export const GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_HEIGHT = '136';
export const GOOGLE_MAPS_STATIC_IMAGE_TABLET_WIDTH = '650';
export const GOOGLE_MAPS_STATIC_IMAGE_TABLET_HEIGHT = '94';
export const GOOGLE_MAPS_STATIC_IMAGE_MOBILE_WIDTH = '450';
export const GOOGLE_MAPS_STATIC_IMAGE_MOBILE_HEIGHT = '105';
export const GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_WIDTH = '100%';
export const GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_HEIGHT = 'auto';

export const staticUrlQueryParams = {
  desktopWidth: GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_WIDTH,
  desktopHeight: GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_HEIGHT,
  mobileWidth: GOOGLE_MAPS_STATIC_IMAGE_MOBILE_WIDTH,
  mobileHeight: GOOGLE_MAPS_STATIC_IMAGE_MOBILE_HEIGHT,
  tabletWidth: GOOGLE_MAPS_STATIC_IMAGE_TABLET_WIDTH,
  tabletHeight: GOOGLE_MAPS_STATIC_IMAGE_TABLET_HEIGHT,
  zoom: defaultZoomLevel
};
